import React from 'react'
import { Box } from '@mui/material'
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsGrid } from '@mui/x-charts/ChartsGrid';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsTooltip } from "@mui/x-charts/ChartsTooltip";
import { ChartsAxisHighlight } from '@mui/x-charts/ChartsAxisHighlight';
import custom from '../../../styles/mui/szPaletteOverrides.json'

export default function ChargeLevelChart({ id, content, tickInterval, margin }: any) {
    return (
        <Box width = "100%" id={id+'ChargeLevelChart'}>
            <ResponsiveChartContainer 
                    series= {[{ type:'bar', 
                                data: content.series, 
                                label: 'Charge level', id, 
                                color: custom.palette.battery.main,
                                valueFormatter: (val:any)=>val+'%'
                            }]} 
                    xAxis={[{ data: content.xAxesLabels, 
                              scaleType: 'band', 
                              id: 'x-axis-id',
                              valueFormatter: (val, context) =>
                                context.location === 'tick'
                                  ? val
                                  : val.endsWith('m')
                                    ? val
                                    : val.endsWith(' ')
                                        ? val.replace(' ','pm')
                                        : `${val}am`
                            }]}
                    height={200}
                    margin={margin} >
                <BarPlot />
                <ChartsGrid horizontal={true}  />
                <ChartsXAxis position="bottom" axisId="x-axis-id" 
                    disableTicks={true} 
                    tickLabelPlacement='middle' 
                    tickInterval={tickInterval}/>
                <ChartsYAxis position="right" 
                    disableTicks={true} 
                    tickLabelPlacement='tick' 
                    tickInterval={[0,25,50,75,100]}
                    valueFormatter={((v: any)=>(v===100?`${v}%`:v))}
                    />
                <ChartsTooltip />
                <ChartsAxisHighlight x="line" y="none" />
            </ResponsiveChartContainer>
        </Box>
    )
}